import LaunchArticle from './LaunchArticle';

export default LaunchArticle;
